import { useCallback, useState } from "react";
import { useLenis, scrollToId } from "../components/site/smooth";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Gallery } from "../components/site/Gallery";
import { ArtworkModal } from "../components/site/ArtworkModal";
import { About } from "../components/site/About";
import { Hearts } from "../components/site/Hearts";
import { Expo } from "../components/site/Expo";
import { Contact } from "../components/site/Contact";
import { Newsletter } from "../components/site/Newsletter";
import { Footer } from "../components/site/Footer";
import { PaymentReturn } from "../components/site/PaymentReturn";
import { CartDrawer } from "../components/site/CartDrawer";
import { CartProvider, useCart } from "../lib/cart";
import { useArtworks } from "../hooks/useArtworks";

export default function Home() {
  return <CartProvider><HomeInner /></CartProvider>;
}

function HomeInner() {
  useLenis();
  const { clear } = useCart();
  const items = useArtworks();
  const [art, setArt] = useState(null);
  const [inquiry, setInquiry] = useState(null);
  const close = useCallback(() => setArt(null), []);
  const inquire = (a) => { setArt(null); setInquiry({ ...a, k: Date.now() }); setTimeout(() => scrollToId("contact"), 350); };

  return (
    <div className="bg-[#F6F1E9] text-[#15202B] f-body overflow-x-clip">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Gallery items={items} onOpen={setArt} />
        <About />
        <Hearts items={items} onOpen={setArt} />
        <Expo />
        <Contact items={items} inquiry={inquiry} />
        <Newsletter />
      </main>
      <Footer />
      <ArtworkModal art={art} onClose={close} onInquire={inquire} />
      <PaymentReturn onPaid={clear} />
      <CartDrawer items={items} />
    </div>
  );
}
